<!--
 * @Author: 曹捷
 * @Date: 2022-03-10 10:37:21
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-07-01 15:45:15
 * @Description: 各种环境统一判断
-->
<template>
  <slot name="zs" v-if="ENV ==='ZS'"></slot>
  <slot name="xj" v-else-if="ENV ==='XJ'"></slot>
  <slot v-else></slot>
</template>

<script setup>
let ENV = sessionStorage.getItem('SENV')
</script>

<style>
</style>